Core.Config = {
    MobileWidth: 767, //set the max width of the mobile view port. options: integer
    TabletWidth: 1024, //set the max width for the tablet view port. optioins: integer
    Header: {
        SearchToggle: true, //turn the seach box toggle on or off. options: boolean (true / false)
        AutoScalingNavigation: false, //set navigation links to fill the space allowed by the parent container DESKTOP ONLY. options: boolean (true / false)
		MobileMenu: 'slideout', //set the type of mobile menu. options: string (slideOut / dropdown)
		MobileNavigationWidth: 767, //set the max width of the viewport which the mobile menu displays. options: integer
        MobileSubMenuToggle: true,
        MegaMenuDropdownDelay: 500 //navigation drop down delay (in ms)
    },
    Carousel: {
        DesktopSlideMargin: 10, //margin between slides on desktop. options: integer
        MobileSlideMargin: 18, //margin between slides on mobile. options: integer
        MobileSlideCount: 2, //slide count for mobile. options: integer
		Pager: true, //show or hide paging control. options: boolean (true / false)
		Auto: false, //slides will automatically transition. options: boolean (true / false)
        Speed: 1000, //slide transition duration (in ms). options: integer
		Pause: 4000, //the amount of time (in ms) between each auto transitions. options: integer
        InfiniteLoop: true, //if true, clicking "Next" while on the last slide will transition to the first slide and vice-versa. options: boolean (true / false)
        HideControlOnEnd: true, //"Next" control will be hidden on last slide and vice-versa (Only used when infiniteLoop: false). options: boolean (true / false)
		MoveSlides: 0, //number of slides to move on transition. This value must be >= minSlides, and <= maxSlides. If zero, the number of fully-visible slides will be used. options: integer
        PauseOnHover: true //pause when mouse hovers over carousel. options: boolean (true / false)
    },
    Slider: {
        Active: true, //turn the slider on or off. options: boolean (true / false)
        Speed: 1500, //slide transition duration (in ms). options: integer
        //Pause: 4000, //the amount of time (in ms) between each auto transitions. options: integer
		Fx: 'scrollHorz' //set the type of transition effect. options: string (scrollHorz / fade / fadeout / none)
    },
    Forms: {
        InputStyling: true, //styling of radio buttons and checkboxes. options: boolean (true / false)
        DropdownStylingTouchDevices: true, //styling of select boxes for touch devices. options: boolean (true / false)
        DropdownStylingDesktop: true //styling of select boxes for non touch devices. options: boolean (true / false)
    },
    Accordions: {
        Active: true //turn the menu toggle on or off. options: boolean (true / false)
    },
    AccordionTabs: {
        Active: true //turn the accordion tabs on or off. options: boolean (true / false)
    },
    SearchAutoComplete: {
		MinCharacters: 3 //sets the minimum number of characters the user must type before a search is performed
    },
    StoreFinder: {
        MarkerIconPath: "site.resource/images/location-pin.png", //location of the google map icon marker. options: string
        MarkerIconPathNetwork: "site.resource/images/location-pin-purple.png", //location pin for Network Partner (purple)
        MapDetailZoomLevel: 15 //zoom level map appears on details page. options: integer
    },
    ProductDetail: {
        ZoomPopupWidth: 780, //width of zoom popup window. options: integer
        ZoomPopupHeight: 600, //height of zoom popup window. options: integer
        ZoomPanningSpeed: 400, //panning speed of zoom feature. options: integer
        Gallery: {
            SlideMargin: 12,
            SlideWidth: 90, //60,
            MinSlides: 2,
            MaxSlides: 5, //4,
            MoveSlides: 0,
            Auto: false,
            Speed: 1000,
            Pager: false,
            InfiniteLoop: false,
            HideControlOnEnd: true,
            UseCSS: false
        }
    },
    CartNotification: {
        PauseTime: 4000, //pause time of notication window before it closes. options: integer
        Width: 560, //width of notification window. options: integer
        Height: 270 //height of notification window. options: integer
    },
    ResponsiveTables: {
        Active: true //turn the responsive tables on or off. options: boolean (true / false)
    },
    FavouriteText: {
        Add: 'Add to favourites',
        Remove: 'Remove from favourites',
        ErrorTitle: 'Favourite button error'
    },
    POA: {
        Text: "Enquire"
    }
};
